<div class="nav-strip">
    <div class="container-fluid">
        <div class="gov-logo">
            <a title="Government Of India" role="button" class="india-logo">
                <img src="https://cdn.lokos.in/lokos-in/assets/icons/dashboard-icons/navbar-icons/web-icons/indian_flag_tricolor.png"
                    alt="Goverment Of India" width="33" height="22" loading="lazy" fetchpriority="high" />
                {{'governmentOfIndia'| translate}}
            </a>
        </div>
        <div class="actions">
            <div class="language-size">
                <button [ngClass]="{'active': activeButton === 'decrease'}"
                    (click)="changeFontSize('decrease')">A<sup>-</sup></button>
                <button [ngClass]="{'active': activeButton === 'reset'}" (click)="changeFontSize('reset')">A</button>
                <button [ngClass]="{'active': activeButton === 'increase'}"
                    (click)="changeFontSize('increase')">A<sup>+</sup></button>
            </div>
            <div class="hide-ver vertical"></div>
            <button (click)="changeTheme(activeTheme)">
                <img src="https://cdn.lokos.in/day-nrlm/assets/img/{{activeTheme}}.png" alt="">
            </button>
            <div class="vertical"></div>
            <div class="language-selection-container">
                <img src="https://cdn.lokos.in/lokos-in/assets/icons/dashboard-icons/navbar-icons/web-icons/language_icon.svg"
                    alt="globe" width="33" height="24" class="language-logo" loading="lazy"
                    fetchpriority="high" />
                <mat-form-field class="language-selection" id="language-selection">
                    <mat-select class="language-selection-select" [formControl]="languageControl" [panelClass]="'language-panel'">
                        <mat-option [value]="config" *ngFor="let config of languageConfig"
                            class="lang-label-selection">{{config.translation}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
</div>